const tryCatch = thunk => {
  try {
    return [null, thunk()];
  } catch (error) {
    return [error, undefined];
  }
};

export { tryCatch };